import CompanyContainer from "./container/CompanyContainer";
export default CompanyContainer;
